import styled from 'styled-components';

import zIndex from 'consts/zIndex';

export const StickySubmitButtonWrapper = styled.div`
  width: 100%;

  ${props =>
    props.theme.media.mobileOnly`
    z-index: ${zIndex.content};
    background: white;
    position: fixed;
    height: 100px;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-shadow: 0px -5px 8px ${props.theme.colors.transparentDarkestCharcoal};
`};
`;

export const SpacedStickySubmitButtonWrapper = styled(
  StickySubmitButtonWrapper
)`
  margin-top: 35px;
  flex-direction: column;
  height: 150px;
  z-index: 1;
`;
